import { http } from '@/http/axios.js'
export function getIndexStatAPI() {
  return http({
    url: '/api/manage/staff/datav/stat',
    method: 'POST'
  })
}
